import { GroupMemberFragment } from 'services/apollo/fragments/groupFeedFragment';
import { ShareTargetFragment } from 'services/apollo/fragments/coreFragments';
import gql from 'graphql-tag';

// Get Started Feed
export const GroupGetStartedFeedQuery = gql`
  query getGroupGetStartedFeed(
    $groupId: String!
    $includeGroups: Boolean!
    $first: Int!
    $cursor: String!
  ) {
    me {
      userProfile {
        id
      }
    }
    groupById(id: $groupId) {
      id
      name
      getStartedNodes {
        memberId
        memberName
        commonNodes(first: $first, cursor: $cursor) {
          nodes {
            ... on Node {
              id
              isIntegrationConnected
              integrationType
              title
              baseUrl
              url
              modified
              created
              category
              pins
              owners {
                id
                name
                email
                avatarUrl
              }
              accessorInfo(includeGroups: $includeGroups) {
                accessors {
                  ... on Group {
                    id
                    groupName: name
                  }
                  ... on Person {
                    id
                    name
                    email
                    avatarUrl
                  }
                }
                pageInfo {
                  endCursor
                  hasNextPage
                  total
                }
              }
              ...shareTargetResults
              sharingEnabled
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
  ${ShareTargetFragment}
`;

// Activity Feed
export const GroupActivityFeedQuery = gql`
  query getGroupActivityFeed(
    $groupId: String!
    $includeGroups: Boolean!
    $first: Int!
    $cursor: String!
  ) {
    groupById(id: $groupId) {
      id
      name
      groupType
      haveNodesInCommon
      activityFeed(first: $first, cursor: $cursor) {
        nodes {
          ... on Node {
            id
            isIntegrationConnected
            integrationType
            title
            baseUrl
            url
            modified
            created
            category
            pins
            owners {
              id
              name
              email
              avatarUrl
            }
            accessorInfo(includeGroups: $includeGroups) {
              accessors {
                ... on Group {
                  id
                  emoji
                  groupName: name
                }
                ... on Person {
                  id
                  name
                  email
                  avatarUrl
                }
              }
              pageInfo {
                endCursor
                hasNextPage
                total
              }
            }
            ...shareTargetResults
            sharingEnabled
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          total
        }
      }
      ...groupMemberResults
    }
  }
  ${ShareTargetFragment}
  ${GroupMemberFragment}
`;

// People Feed
export const GroupPeopleFeedQuery = gql`
  query getGroupPeopleFeed($groupId: String!) {
    groupById(id: $groupId) {
      id
      name
      isAdmin
      ...groupMemberResults
    }
  }
  ${GroupMemberFragment}
`;

//  Pinned Nodes
export const GroupPinnedFeedQuery = gql`
  query getGroupPinnedFeed(
    $groupId: String!
    $includeGroups: Boolean!
    $first: Int!
    $cursor: String!
  ) {
    groupById(id: $groupId) {
      id
      name
      pinnedNodes(first: $first, cursor: $cursor) {
        nodes {
          ... on Node {
            id
            isIntegrationConnected
            integrationType
            title
            baseUrl
            url
            modified
            created
            category
            pins
            owners {
              id
              name
              email
              avatarUrl
            }
            accessorInfo(includeGroups: $includeGroups) {
              accessors {
                ... on Group {
                  id
                  groupName: name
                }
                ... on Person {
                  id
                  name
                  email
                  avatarUrl
                }
              }
              pageInfo {
                endCursor
                hasNextPage
                total
              }
            }
            ...shareTargetResults
            sharingEnabled
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          total
        }
      }
    }
  }
  ${ShareTargetFragment}
`;

// Add to group modal
export const AddMemberModalQuery = gql`
  query getMembersToAddToGroupModal($groupId: String!) {
    me {
      organization {
        id
        name
      }
      # Sections
      userProfile {
        id
        email
        organization {
          id
          name
          type
        }
      }
      # People in my organization
      orgGroup {
        id
        name
        groupType
        members {
          ... on Person {
            id
            name
            email
            avatarUrl
          }
        }
      }
      # Other people
      otherPeople {
        id
        email
        name
        avatarUrl
      }
    }
    # Members already in group (in order to diff)
    groupById(id: $groupId) {
      id
      ...groupMemberResults
    }
  }
  ${GroupMemberFragment}
`;

// Group Sidebar: People in group
// A seperate query to keep unqiue query name
export const GroupPeopleQuery = gql`
  query getGroupPeople($groupId: String!) {
    groupById(id: $groupId) {
      id
      name
      isAdmin
      ...groupMemberResults
    }
  }
  ${GroupMemberFragment}
`;

export const GroupSummaryQuery = gql`
  query getGroupSummary($groupId: String!) {
    groupById(id: $groupId) {
      id
      name
      pinnedNodes {
        pageInfo {
          total
        }
      }
      activityFeed {
        pageInfo {
          total
        }
      }
    }
  }
`;

export const GroupGetStartedConditionQuery = gql`
  query getGroupGetStartedCondition($groupId: String!) {
    groupById(id: $groupId) {
      id
      groupType
      haveNodesInCommon
      activityFeed(first: 10, cursor: "") {
        pageInfo {
          total
        }
      }
      members {
        ... on Person {
          id
        }
      }
    }
  }
`;
